export const WORKSPACE_CODE_OWNED_PAGE_ID = 'page-workspace';
export const WORKSPACE_CODE_OWNED_PAGE_PATH = '/workspace';

export function isWorkspaceCodeOwnedPagePath(path: string) {
  return (
    `/${path.trim().replace(/^\/+|\/+$/gu, '')}` ===
    WORKSPACE_CODE_OWNED_PAGE_PATH
  );
}
